import { useEffect, useRef } from 'react'
import { ArcaplanetLogoGlobal } from 'src/components/icons/ArcaplanetLogoGlobal'
import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { LEVELS } from '../constants'
import { MenuSection } from './MenuComponents/MenuSection/MenuSection'
import { TopCategorySection } from './MenuComponents/MenuSection/TopCategorySection'

export const FirstLevel = () => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const { menuSections, openCloseMenu } = useGlobalNavigation()

  useEffect(() => {
    if (openCloseMenu) {
      scrollRef?.current?.scrollTo(0, 0)
    }
  }, [openCloseMenu])

  return (
    <div className="w-[360px] h-screen navigation-panel-step active">
      <div className="px-6 pt-10 pb-3 bg-white rounded-tr-2xl h-[105px] global-navigation-header">
        <div className="relative w-full flex justify-between">
          <div className="p-1">
            <ArcaplanetLogoGlobal />
            <span className="pt-1.5 block font-semibold !leading-[130%] tracking-[0.035px] text-sm">
              Tutte le categorie
            </span>
          </div>
        </div>
      </div>
      <div className="h-[calc(100%-105px)] w-full overflow-hidden rounded-br-2xl bg-white global-navigation-body">
        <div className="h-full w-full relative">
          <div
            className="h-full transition-all overflow-auto lg:w-[360px]"
            ref={scrollRef}
          >
            <div className="pl-3 pr-6 pt-6 [&>div:last-child]:border-none">
              {menuSections.map((el, index: number) => (
                <MenuSection
                  key={`section-menu-desktop-${index}`}
                  menu={el}
                  type={LEVELS.main.toString()}
                />
              ))}
            </div>
            <TopCategorySection />
          </div>
        </div>
      </div>
    </div>
  )
}
